<h2 class="preorder-type-chip">
	{{ 'preorder_type.' + preorderType | translate }}
</h2>
